// extracted by mini-css-extract-plugin
module.exports = {"grid":"OutsourcersList_grid__3BMIA"};